import { EntityService } from "../EntityService";
import { Image } from "./Image";
import { TYPES } from "../../EntityManager";
import { Loader, Sprite, Texture } from 'pixi.js-legacy'
import { graphic } from "../../Graphic";

export class ImageService extends EntityService {

    static upsertFromProps(imagesProps) {
        super.upsertFromProps(TYPES.IMAGE, imagesProps);
    }

    static createGraphicItem(props, onBuild) {
        let texture = Texture.from(props.path, {
            resourceOptions: {
                crossorigin: false
            }
        });
        let image = new Sprite(texture);
        image.anchor.set(0.5);
        onBuild(image)
    }

    static createFromProps(props) {
        const { id, container } = super.createFromProps(props);
        const image = new Image({ id, container, graphicItems: [], width: props.width, height: props.height, name: props.name });
        ImageService.createGraphicItem(props, (item) => {
            image.graphicItems.push(item);
            image.draw();
            graphic.center();
        });
        return image;
    }

    static changeRatio({ imagesIds, value }) {
        imagesIds.forEach(imageId => {
            const entity = graphic.entityManager.get(TYPES.IMAGE, imageId);
            if (entity && value) entity.container.scale = {
                x: value / 100,
                y: value / 100
            };
        });
    }
}